export default "__VITE_ASSET__Bkuh3YfK__"